import PropTypes from 'prop-types';

import { useRef, useState } from 'react';

import {
  Modal,
  Form,
  Input,
  Select,
  Row,
  Col,
  Upload,
  Image,
  message,
} from 'antd';
import Draggable from 'react-draggable';
import { customRequest, normFile, onPreview } from './common';
import { rules } from '@/utils/validation/FormValidation';
import { optionSearchFunction } from '@/utils/common';
import GlobalDivider from '@/utils/divider/GlobalDivider';
// import { useGetApiList } from '@/apiError/apiShow';
import { companyAccessEndpoints, countryApiEndPoints } from '@/api/endpoints';
import { useFetch } from '@/hooks';
import imageCompression from 'browser-image-compression';
import { AntSwitch } from '@/common/ant-components/AntSwitch';
import { AntInput } from '@/common/ant-components/AntInput';
import { AntInputNumber } from '@/common/ant-components/AntInputNumber';

/**
 *
 *  draggable modal form for crud operation like create, edit
 * @param {Object} param
 * @returns
 */

const BranchFormModal = ({
  open,
  handleCancel,
  handleOk,
  title,
  form,
  calculationType,
  imageUrl,
  setImageUrl,
  renameFile,
  referenceId,
}) => {
  const fieldsValue = Form.useWatch([], form);
  const [fileList, setFileList] = useState([]);
  const [previewImage, setPreviewImage] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [bounds, setBounds] = useState({
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
  });

  const draggleRef = useRef(null);
  const [dialCode, setDialCode] = useState('+977');
  const [mobileRegex, setMobileRegex] = useState(
    '^(984|985|986|974|975|976|980|981|982|961|962|988)\\d{7}$',
  );
  const [panRegex, setPanRegex] = useState('^\\d{9}$');

  const onStart = (_event, uiData) => {
    const { clientWidth, clientHeight } = window.document.documentElement;
    const targetRect = draggleRef.current?.getBoundingClientRect();
    if (!targetRect) {
      return;
    }
    setBounds({
      left: -targetRect.left + uiData.x,
      right: clientWidth - (targetRect.right - uiData.x),
      top: -targetRect.top + uiData.y,
      bottom: clientHeight - (targetRect.bottom - uiData.y),
    });
  };

  const beforeUpload = async (file) => {
    const isValidType = ['image/jpeg', 'image/png', 'image/jpg'].includes(
      file.type,
    );
    if (!isValidType) {
      messageApi.error('Only JPG, JPEG, and PNG files are allowed!');
      return false;
    }
    const maxSize = 500;
    const fileSize = file?.size / 1024 <= maxSize;
    if (!fileSize) {
      messageApi.error('File size should be less than 500 KB');
      return false;
    }
    const options = {
      maxSize: 0.5,
      maxWidthOrHeight: 1024,
      useWebWorker: true,
    };
    try {
      const compressedFile = await imageCompression(file, options);
      return renameFile(compressedFile);
    } catch (error) {
      console.error('Compression error:', error);
      return false; // Prevent upload
    }
  };

  // const renameFile = (compressedFile) => {
  //   // const companyName = data?.filter(
  //   //   (item) => item.referenceId === form.getFieldValue('companyId'),
  //   // )[0]?.name;
  //   const extension = compressedFile?.name?.split('.').pop();
  //   const branchName = form.getFieldValue('name')?.split(' ').join('');
  //   const newFileName = branchName
  //     ? `${branchName}.${extension}`
  //     : compressedFile?.name;
  //   const newFile = new File([compressedFile], newFileName, {
  //     type: compressedFile.type,
  //   });
  //   return newFile;
  // };

  const onChange = ({ fileList: newFileList }) => {
    const maxSize = 500; // KB

    // Filter only valid files
    const filteredList = newFileList.filter((file) => {
      const isValidType = ['image/jpeg', 'image/png', 'image/jpg'].includes(
        file.type,
      );
      const isValidSize = file.size / 1024 <= maxSize;

      return isValidType && isValidSize;
    });

    // Update state
    setFileList(filteredList);
    form.setFieldsValue({ photo: filteredList[0] });
  };

  const onRemove = (file) => {
    if (file.url) {
      setImageUrl(null);
    }

    setFileList([]);
    form.setFieldsValue({ photo: [] });

    return true;
  };

  // const { data: { data } = {}, isPending: companyLoading } = useGetApiList(
  //   'company/access/list/',
  // );

  const { data, isLoading: companyLoading } = useFetch(
    companyAccessEndpoints.retrieveList,
  );
  const { data: country, isLoading: countryLoading } = useFetch(
    countryApiEndPoints.retreiveList,
  );
  // const { data: { data: country } = {}, isPending: countryLoading } =
  //   useGetApiList('admin/countries/');

  const handleCountryChange = (value) => {
    const filterData = country.filter((item) => item.referenceId === value);
    setDialCode(filterData[0]?.dialCode);
    setPanRegex(filterData[0]?.patVatPattern);
    setMobileRegex(filterData[0]?.mobilePattern);
  };

  const watchVat = Form.useWatch('isVatApplicable', form);
  const watchTax = Form.useWatch('isLuxuryTaxApplicable', form);

  return (
    <>
      {contextHolder}
      <Modal
        forceRender
        destroyOnHidden
        title={
          <div className="text-center my-3 tw-font-semibold tw-text-xl">
            {title
              .split(' ')
              .map((word) => word.split('')[0].toUpperCase() + word.slice(1))
              .join(' ')}
          </div>
        }
        open={open}
        width={1000}
        height={700}
        centered={true}
        onOk={() => form.submit()}
        cancelButtonProps={{
          type: 'danger',
          style: { backgroundColor: 'red', color: '#fff' },
        }}
        onCancel={handleCancel}
        // modalRender={(modal) => (
        //   <Draggable
        //   // disabled={disabled}
        //   // bounds={bounds}
        //   // nodeRef={draggleRef}
        //   // onStart={(event, uiData) => onStart(event, uiData)}
        //   >
        //     <div ref={draggleRef}>{modal}</div>
        //   </Draggable>
        // )}
      >
        <Form
          form={form}
          onFinish={() => handleOk(fieldsValue, form)}
          layout="vertical"
          initialValues={{ calculationType: 'gm', showImage: false }}
        >
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                className="font-bold"
                label="Country"
                name="countryId"
                rules={rules.required}
                validateTrigger="onChange"
              >
                <Select
                  showSearch
                  loading={countryLoading}
                  placeholder="Select Country"
                  filterOption={optionSearchFunction}
                  options={country?.map((item) => {
                    return {
                      value: item.referenceId,
                      label: item?.name,
                    };
                  })}
                  onChange={handleCountryChange}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                className="font-bold"
                label="Company"
                name="companyId"
                rules={rules.required}
                validateTrigger="onChange"
              >
                <Select
                  showSearch
                  loading={companyLoading}
                  placeholder="Select Company"
                  filterOption={optionSearchFunction}
                  options={data?.map((item) => {
                    return {
                      value: item.referenceId,
                      label: item?.name,
                    };
                  })}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                className="font-bold"
                label="Name"
                name="name"
                rules={rules.required}
                validateTrigger="onChange"
              >
                <Input placeholder="Branch" autoComplete="off" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                className="font-bold tw-w-full"
                label="Address 1"
                name="address"
                rules={rules.required}
                validateTrigger="onChange"
              >
                <Input placeholder="Address 1" autoComplete="off" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                className="font-bold tw-w-full"
                label="Address 2"
                name="address2"
                // rules={rules.required}
                validateTrigger="onChange"
              >
                <Input placeholder="Address 2" autoComplete="off" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                className="font-bold tw-w-full"
                label="Mobile No"
                name="mobileNumber"
                rules={rules.required}
                // rules={[
                //   {
                //     required: true,
                //     message: 'This field is required',
                //   },
                //   {
                //     pattern: new RegExp(mobileRegex),
                //     message: 'Invalid Mobile Number',
                //   },
                // ]}
                // validateTrigger="onChange"
              >
                <Input
                  addonBefore={<div>{dialCode}</div>}
                  placeholder="mobile"
                  autoComplete="off"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                className="font-bold tw-w-full"
                label="Email"
                name="email"
                rules={rules.required}
                validateTrigger="onChange"
              >
                <Input placeholder="Email" autoComplete="off" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                className="font-bold tw-w-full"
                label="Pan No"
                name="panVat"
                // rules={[
                //   {
                //     required: true,
                //     message: 'This field is required',
                //   },
                //   {
                //     pattern: new RegExp(panRegex),
                //     message: 'Invalid Pan Number',
                //   },
                // ]}
                // validateTrigger="onChange"
              >
                <Input placeholder="Pan No" maxLength={9} autoComplete="off" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                className="font-bold tw-w-full"
                label="Website"
                name="website"
                validateTrigger="onChange"
              >
                <Input placeholder="Website" autoComplete="off" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                className="font-bold tw-w-full"
                label="Phone No"
                name="phone"
                validateTrigger="onChange"
              >
                <Input placeholder="Phone" autoComplete="off" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <div className="tw-flex tw-gap-x-3">
                <AntSwitch
                  formProps={{
                    label: 'Is Vat Applicable',
                    name: 'isVatApplicable',
                    initialValue: false,
                  }}
                  onChange={(e) => {
                    if (!e) {
                      form.setFieldsValue({
                        vatPercent: null,
                      });
                    }
                  }}
                  className="username"
                />

                <AntInputNumber
                  type="number"
                  formProps={{
                    name: 'vatPercent',
                    label: 'Vat Percent',
                    rules: [
                      {
                        validator: (_, value) => {
                          if (!watchVat) {
                            return Promise.resolve();
                          }
                          if (
                            value === undefined ||
                            value === null ||
                            value <= 0
                          ) {
                            return Promise.reject(
                              'Value must be greater than 0',
                            );
                          }
                          if (value > 100) {
                            return Promise.reject(
                              'Value cannot be greater than 100',
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ],
                  }}
                  maxLength={3}
                  disabled={!watchVat}
                />
              </div>
            </Col>

            <Col span={8}>
              <div className="tw-flex tw-gap-x-3">
                <AntSwitch
                  formProps={{
                    label: 'Is Tax Applicable',
                    name: 'isLuxuryTaxApplicable',
                  }}
                  onChange={(e) => {
                    if (!e) {
                      form.setFieldsValue({
                        luxuryTaxPercent: 0,
                      });
                    }
                  }}
                  className="username"
                />

                <AntInputNumber
                  type="number"
                  maxLength={3}
                  formProps={{
                    name: 'luxuryTaxPercent',
                    label: 'Tax Percent',
                    // required: watchTax ? true : false,
                    rules: [
                      {
                        validator: (_, value) => {
                          if (!watchTax) {
                            return Promise.resolve();
                          }
                          if (
                            value === undefined ||
                            value === null ||
                            value <= 0
                          ) {
                            return Promise.reject(
                              'Value must be greater than 0',
                            );
                          }
                          if (value > 100) {
                            return Promise.reject(
                              'Value cannot be greater than 100',
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ],
                  }}
                  disabled={!watchTax}
                />
              </div>
            </Col>
            <Col span={8}>
              <Form.Item
                className="font-bold tw-w-full"
                label="Tax Label Name"
                name="taxLabelName"
                rules={[
                  {
                    required: true,
                    message: 'This field is required',
                  },
                ]}
              >
                <Input placeholder="Enter tax label name" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                className="font-bold tw-w-full"
                label="Silver Threshold Amount"
                name="silverThresholdAmount"
                validateTrigger="onChange"
                initialValue={0}
              >
                <AntInputNumber type="number" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                className="font-bold tw-w-full"
                name="calculateOnPure"
                label="Calculate Both Wholesale and Retail"
                valuePropName="checked"
              >
                <AntSwitch className="username" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                className="font-bold tw-w-full"
                name="showImage"
                label="Show Image"
                valuePropName="checked"
              >
                <AntSwitch className="username" />
              </Form.Item>
            </Col>
          </Row>

          <GlobalDivider orientation="center" name="Company Settings" />

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                className="font-bold"
                label="Date Type"
                name="dateFormatType"
                initialValue="ad"
                rules={[
                  {
                    required: true,
                    message: 'This field is required',
                  },
                ]}
              >
                <Select>
                  <Select.Option value="ad">A. D.</Select.Option>
                  <Select.Option value="bs">B. S.</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                className="font-bold"
                label="Calculation Type"
                name="calculationType"
                rules={[
                  {
                    required: true,
                    message: '',
                  },
                ]}
              >
                <Select
                  onSelect={() => {
                    message.destroy();
                    message.warning({
                      content:
                        'Once Primary Calculation is Set it can not be changed ever again',
                    });
                  }}
                  disabled={calculationType}
                >
                  <Select.Option value="gm">Gram</Select.Option>
                  <Select.Option value="lal">Lal</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                className="username text-start"
                label="Company Profile"
                name="photo"
                valuePropName="file"
                validateTrigger="onChange"
                getValueFromEvent={normFile}
                // rules={[
                //   {
                //     validator: async (rule, file) => {
                //       if (!file) {
                //         return Promise.reject('Please upload a file');
                //       }
                //       if (typeof file === 'string') return Promise.resolve();
                //       const isValidType = [
                //         'image/png',
                //         'image/jpeg',
                //         'image/jpg',
                //       ].includes(file.type);
                //       if (!isValidType) {
                //         return Promise.reject(
                //           'Only PNG, JPEG, JPG files are allowed',
                //         );
                //       }
                //
                //       const isValidSize = file.size <= 1 * 1024 * 1024;
                //       if (!isValidSize) {
                //         return Promise.reject('File must be smaller than 1MB');
                //       }
                //
                //       return Promise.resolve();
                //     },
                //   },
                // ]}
              >
                <Upload
                  listType="picture-card"
                  // fileList={fileList}
                  accept=".jpg, .jpeg, .png, .gif"
                  fileList={
                    imageUrl ? [{ uid: '-1', url: imageUrl }] : fileList
                  }
                  customRequest={customRequest}
                  onChange={onChange}
                  onPreview={(file) =>
                    onPreview(file, setPreviewImage, setPreviewOpen)
                  }
                  onRemove={onRemove}
                  beforeUpload={beforeUpload}
                  maxCount={1}
                >
                  {fileList?.length < 5 && '+ Upload'}
                </Upload>
              </Form.Item>
              {previewImage && (
                <Image
                  wrapperStyle={{ display: 'none' }}
                  preview={{
                    visible: previewOpen,
                    onVisibleChange: (visible) => setPreviewOpen(visible),
                    afterOpenChange: (visible) =>
                      !visible && setPreviewImage(''),
                  }}
                  src={previewImage}
                />
              )}
            </Col>
          </Row>

          <GlobalDivider orientation="center" name="IRD Settings" />

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                className="font-bold"
                label="Username"
                name="irdUsername"
                rules={[
                  {
                    required: true,
                    message: 'This field is required',
                  },
                ]}
              >
                <Input placeholder="Enter Username" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                className="font-bold"
                label="Password"
                name="irdPassword"
                rules={[
                  {
                    required: referenceId ? false : true,
                    message: '',
                  },
                ]}
              >
                <Input.Password
                  initialValue={''}
                  type="password"
                  placeholder="Enter Password"
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

BranchFormModal.propTypes = {
  open: PropTypes.bool,
  handleOk: PropTypes.func,
  handleCancel: PropTypes.func,
  title: PropTypes.string,
  form: PropTypes.object, // form for useForm
};

export default BranchFormModal;
